<template>
  <div
    v-for="(message, idx) in conversation.messages"
    :key="idx"
  >
    {{ message.role === 'user' ? message.name : characterId }}: {{ message.emotion ? `(${message.emotion})`: '' }} {{ message.content }}
    {{ message.voicefile ? `(${message.voicefile})` : '' }}
  </div>
</template>
<script setup lang="ts">
import { PollConversation } from '../../../../common/src/Types'
import { CharacterId } from '../../../../common/src/Characters'

defineProps<{
  conversation: PollConversation
  characterId: CharacterId
}>()
</script>
